/* eslint-disable @typescript-eslint/no-explicit-any */
import { assetFragment, articleFragment } from "../fragments";
import {
    ITemplatePageLoader,
    flattenTemplateImageAssets
} from "../get-content-data";

export const AgileArticlePageLoader: ITemplatePageLoader = {
    getQueryData: (urlSlug: string, locale: string) => {
        return {
            query: `
                query getAgileArticle ($search: ContentPlatformSearchAPIv2Query!) {
                    fullHubArticles(search: $search) {
                        edges {
                            node {
                                ...articleFragmentFull
                            }
                        }
                    }
                }
                ${articleFragment}
                ${assetFragment}
            `,
            variables: {
                search: {
                    queries: {
                        first: 1,
                        withLocales: [locale],
                        where: {
                            searchText: {
                                exactlyMatching: {
                                    fieldNamed: "articleRef.urlSlug",
                                    havingValues: [urlSlug]
                                }
                            }
                        }
                    }
                }
            }
        };
    },
    parseData: (data: any) => {
        const flattenedArticle = flattenTemplateImageAssets(
            data.fullHubArticles?.edges[0]?.node ?? {}
        );
        return { ...flattenedArticle, ...flattenedArticle.articleRef };
    }
};
